<div class="dialoghead dynamic-ritual-praxis-choose-modal">
  <h2 mat-dialog-title>Ritual Configuration</h2>
</div>

<mat-dialog-content class="mat-typography">
  <label class="dropdown-section-label">Choose Ritual Type</label>

  <mat-radio-group class="new-radio" [formControl]="selectedAction">
    <mat-radio-button value="invocation">Invocation</mat-radio-button>
    <mat-radio-button value="banishing">Banishing</mat-radio-button>
  </mat-radio-group>

  <div class="dropdown-container">
    <label class="dropdown-section-label">Choose Planets</label>

    <mat-form-field appearance="outline" class="full-width-dropdown">
      <mat-label>Select one or more planets</mat-label>
      <mat-select [formControl]="selectedPlanets" multiple>
        <mat-option *ngFor="let planet of planets" [value]="planet">
          <span class="element-color" [ngStyle]="{ 'background-color': getElementColorHex(planet.element) }"></span>
          <span class="icon" [innerHTML]="safeSvg(planet.svg)"></span>
          <span>{{ planet.name }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="selected-options-display">
      <mat-chip-listbox aria-label="Selected planets">
        <mat-chip *ngFor="let planet of selectedPlanetsList" selectable="false" removable="true" (removed)="removePlanet(planet)">
          <span class="icon" [innerHTML]="safeSvg(planet.svg)"></span>
          {{ planet.name }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-listbox>
    </div>
  </div>

  <div *ngIf="!isBanishing" class="dropdown-container">
    <label class="dropdown-section-label">Choose Zodiac Signs</label>

    <mat-form-field appearance="outline" class="full-width-dropdown">
      <mat-label>Select one or more zodiac signs</mat-label>
      <mat-select [formControl]="selectedZodiacs" multiple [disabled]="isBanishing">
        <mat-option *ngFor="let zodiac of zodiacs" [value]="zodiac">
          <span class="element-color" [ngStyle]="{ 'background-color': getElementColorHex(zodiac.element) }"></span>
          <span class="icon" [innerHTML]="safeSvg(zodiac.svg)"></span>
          <span>{{ zodiac.name }}</span>
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="isBanishing">Disabled in Banishing mode</mat-hint>
    </mat-form-field>

    <div class="selected-options-display">
      <mat-chip-listbox aria-label="Selected zodiacs">
        <mat-chip *ngFor="let zodiac of selectedZodiacsList" selectable="false" removable="true" (removed)="removeZodiac(zodiac)">
          <span class="icon" [innerHTML]="safeSvg(zodiac.svg)"></span>
          {{ zodiac.name }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-listbox>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="onSubmit()">Submit</button>
</mat-dialog-actions>

<span mat-button mat-dialog-close class="close-btn-modal material-icons"
    >close</span
  >

  <ng-container *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-container>


<style>
/* =========================================
   Dialog + Content
   ========================================= */
::ng-deep .custom-modalbox .dialoghead {
  position: relative;
  padding: 8px 8px 0;
}
::ng-deep .custom-modalbox .dialoghead h2.mat-mdc-dialog-title {
  margin: 14px 0 6px;
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  letter-spacing: .2px;
}
::ng-deep .custom-modalbox mat-dialog-content {
  padding: 10px 16px 2px;
  color: #e6e9ef;
}

/* =========================================
   Radio Group
   ========================================= */
::ng-deep .custom-modalbox .new-radio {
  display: flex;
  gap: 24px;
  align-items: center;
  /* MODIFIED: Adjusted margin for better spacing with the new label */
  margin: 0 0 18px; 
}
::ng-deep .custom-modalbox .new-radio .mdc-form-field {
  color: #d7dbe4;
  font-size: 14px;
}
::ng-deep .custom-modalbox .mat-mdc-radio-button .mdc-radio__outer-circle { border-color: #9aa3b2; }
::ng-deep .custom-modalbox .mat-mdc-radio-button.mat-mdc-radio-checked .mdc-radio__outer-circle { border-color: #ff9800; }
::ng-deep .custom-modalbox .mat-mdc-radio-button .mdc-radio__inner-circle { background-color: #ff9800; }

/* =========================================
   SECTION LABEL STYLES (Applies to all labels)
   ========================================= */
::ng-deep .custom-modalbox .dropdown-section-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #d7dbe4;
  margin-bottom: 8px;
}

/* =========================================
   Form Field / Select (trigger)
   ========================================= */
::ng-deep .custom-modalbox .dropdown-container { margin-bottom: 18px; }
::ng-deep .custom-modalbox .full-width-dropdown { width: 100%; }
::ng-deep .custom-modalbox .mdc-notched-outline__leading,
::ng-deep .custom-modalbox .mdc-notched-outline__notch,
::ng-deep .custom-modalbox .mdc-notched-outline__trailing {
  border-color: #3b4252 !important;
}
::ng-deep .custom-modalbox .mat-mdc-form-field.mat-focused .mdc-notched-outline__leading,
::ng-deep .custom-modalbox .mat-mdc-form-field.mat-focused .mdc-notched-outline__notch,
::ng-deep .custom-modalbox .mat-mdc-form-field.mat-focused .mdc-notched-outline__trailing {
  border-color: #ff9800 !important;
}
::ng-deep .custom-modalbox .mdc-floating-label,
::ng-deep .custom-modalbox .mat-mdc-select .mat-mdc-select-trigger,
::ng-deep .custom-modalbox .mat-mdc-select-arrow {
  color: #e6e9ef;
}

/* =========================================
   Select Panel (CDK overlay) + Options
   ========================================= */
::ng-deep .cdk-overlay-container .mat-mdc-select-panel {
  background: #242a36;
  color: #e6e9ef;
  border: 1px solid #313849;
  border-radius: 10px !important;
  box-shadow: 0 18px 44px rgba(0,0,0,0.55);
  max-height: 360px !important;
}
::ng-deep .cdk-overlay-container .mat-mdc-option {
  min-height: 42px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}
::ng-deep .cdk-overlay-container .mat-mdc-option .mdc-list-item__primary-text{
    display: flex;
    align-items: center;
    gap: 5px
}
::ng-deep .cdk-overlay-container .mat-mdc-option:hover {
  background: #2a3040;
}
::ng-deep .cdk-overlay-container .mat-mdc-option.mdc-list-item--selected {
  background: rgba(255,152,0, .12);
  color: #ffd18a;
}
::ng-deep .cdk-overlay-container .mat-pseudo-checkbox-checked,
::ng-deep .cdk-overlay-container .mat-pseudo-checkbox-indeterminate {
  background: #ff9800 !important;
  border-color: #ff9800 !important;
}
::ng-deep .cdk-overlay-container .mat-mdc-option .icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  color: currentColor;
}
::ng-deep .cdk-overlay-container .mat-mdc-option .icon svg {
  width: 25px;
  height: 25px;
  display: block;
  margin-right: 5px;
}
::ng-deep .cdk-overlay-container .mat-mdc-option .element-color{
  width: 10px;
  height: 10px;
  border-radius: 10px;
}
::ng-deep .cdk-overlay-container .mat-mdc-select-panel::-webkit-scrollbar { width: 8px; }
::ng-deep .cdk-overlay-container .mat-mdc-select-panel::-webkit-scrollbar-track { background: transparent; }
::ng-deep .cdk-overlay-container .mat-mdc-select-panel::-webkit-scrollbar-thumb {
  background: #3a4254; border-radius: 8px;
}
::ng-deep .cdk-overlay-container .mat-mdc-select-panel::-webkit-scrollbar-thumb:hover {
  background: #475069;
}

/* =========================================
   Chips (selected items preview)
   ========================================= */
::ng-deep .custom-modalbox .selected-options-display { margin-top: 10px; }
::ng-deep .custom-modalbox .mat-mdc-chip {
  background: #2a3040;
  color: #e6e9ef;
  border: 1px solid #3b4252;
  border-radius: 50px;
  height: 32px;
}
::ng-deep .custom-modalbox .mat-mdc-chip .mat-icon {
  color: #9aa3b2;
}
::ng-deep .mat-mdc-chip.mdc-evolution-chip--with-trailing-action .mat-mdc-chip-action-label{
  display: flex;
  align-items: center;
}
::ng-deep .mat-mdc-chip.mdc-evolution-chip--with-trailing-action .mat-mdc-chip-action-label .icon {
  margin-right: 2px !important;
}
::ng-deep .custom-modalbox .mat-mdc-chip .icon {
  width: 18px; height: 18px; margin-right: 6px;
}
::ng-deep .custom-modalbox .mat-mdc-chip .icon svg {
  width: 18px; height: 18px; display: block;
}

/* =========================================
   Footer actions
   ========================================= */
::ng-deep .custom-modalbox mat-dialog-actions {
  padding: 8px 16px 16px;
}
::ng-deep .custom-modalbox [mat-flat-button][color="primary"] {
  background: linear-gradient(180deg, #ffb74d, #ff9800);
  color: #1a1d24;
  font-weight: 700;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(255,152,0,.25);
}
::ng-deep .custom-modalbox [mat-flat-button][color="primary"]:hover {
  box-shadow: 0 10px 24px rgba(255,152,0,.35);
  transform: translateY(-1px);
}
</style>